import React from 'react';
import { Mic } from 'lucide-react';
export function Header() {
  return <header className="bg-brand-green px-4 md:px-6 py-3 md:py-3.5 flex items-center justify-center gap-2 md:gap-3" data-id="element-48">
      <Mic className="w-4 h-4 text-brand-white/80" strokeWidth={2} data-id="element-49" />
      <span className="text-brand-white/90 font-semibold text-[11px] md:text-[13px] tracking-[0.12em] uppercase" data-id="element-50">
        Tu Manual Digital
      </span>
    </header>;
}